export default __webpack_public_path__ + "static/media/RedFilled_Ribbon.a9720417.svg";